import { jsx } from "react/jsx-runtime";
import react from "react";
import { ToastPanel } from "./ToastPanel.js";
import { v4 } from "uuid";
import classnames from "classnames";
const toastTypes = [
    'info',
    'success',
    'error',
    'warning',
    'loading'
];
const buildToastInstance = (api)=>{
    const instance = buildToastFunc(api, 'info');
    toastTypes.forEach((type)=>{
        instance[type] = buildToastFunc(api, type);
    });
    instance.open = instance.info;
    instance.destroy = api.destroy;
    return instance;
};
const buildToastFunc = (api, fixedType)=>(...args)=>{
        const params = formatToastArgs(...args);
        const { key, duration, onClose, onClick, style, className, type, closable, ...panelProps } = params;
        const toastKey = key || v4();
        const mergedDuration = 'number' == typeof duration ? duration : closable ? 0 : duration;
        return api.open({
            key: toastKey,
            icon: null,
            onClick,
            onClose,
            style,
            className: classnames('weet-toast', className),
            duration: mergedDuration,
            content: /*#__PURE__*/ jsx(ToastPanel, {
                ...panelProps,
                type: type || fixedType,
                closable: closable,
                onClose: ()=>api.destroy(toastKey)
            })
        });
    };
const formatToastArgs = (first, second, third)=>{
    if ('object' == typeof first && null !== first && !/*#__PURE__*/ react.isValidElement(first)) return first;
    const content = first;
    if ('number' == typeof second) return {
        content,
        duration: second,
        onClose: third
    };
    if ('function' == typeof second) return {
        content,
        onClose: third
    };
    return {
        content
    };
};
export { buildToastInstance, formatToastArgs };
